'use strict';
const React = require('react');
const ReactRedux = require('react-redux');
const BaseComponent = require('../../../../../../../shared/base');

class BookingDetails extends BaseComponent {
    render() {
        return null;
    }
}

module.exports = BookingDetails;